import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Discount from "./DiscountDialog";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { API_URL } from "../../../../api";
const Income = () => {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [origin, setOrigin] = useState(true);
  const [filterList, setFilterList] = useState([]);
  const [showFilterList, setShowFilterList] = useState(false);
  const [disLists, setDisLists] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [open, setOpen] = useState(false);
  const CreateDialog = () => {
    setOpen(true);
  };

  const handleDelete = (event) => {
    console.log(event, "ID");
    api
      .delete("item-discounts/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        const result = disLists.filter((item) => item._id !== event);
        setDisLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleNameFilter = (event) => {
    if (event) {
      setFilterList(
        disLists.filter((el) =>
          (el.discountName || "").toLowerCase().includes(event.toLowerCase()),
        ),
      );
      setShowFilterList(true);
      setOrigin(false);
    } else {
      setShowFilterList(false);

      setOrigin(true);
    }
  };
  useEffect(() => {
    const getDisReqLists = async () => {
      try {
        const res = await api.get("item-discounts");
        setDisLists(res.data.data);

        console.log(res.data.list, "dis");
      } catch (err) {
        alert(err.message);
      }
    };
    getDisReqLists();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
              </div>
            </div>
          </div>

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="row d-flex justify-content-between align-items-center mb-3">
                <div className="col-md-3">
                  <select
                    className="custom-select border-info"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="">All Types</option>
                    <option value="Voucher">Voucher</option>
                    <option value="Expired">Expired Date</option>
                    <option value="quantityBased">Item Base</option>
                  </select>
                </div>
                <div className="col-md-5">
                  <div className="input-group">
                    <input
                      type="search"
                      className="form-control rounded ml-1"
                      style={{ borderRadius: "12px" }}
                      onChange={(e) => handleNameFilter(e.target.value)}
                      placeholder="Search"
                    />
                    <div className="input-group-append ml-2">
                      <button
                        onClick={CreateDialog}
                        className="btn"
                        style={{
                          borderRadius: "7px",
                          backgroundColor: "black",
                          color: "white",
                        }}
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <h5 className="card-header">Discount List</h5>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Discount Name</th>
                                  <th>Discount Type</th>
                                  <th>Product</th>
                                  <th>Item</th>
                                  <th>Expired Days</th>
                                  <th>Item Base Qty</th>
                                  <th>Discount Method</th>
                                  <th>Discount Value</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              {origin && (
                                <tbody>
                                  {disLists
                                    .filter(
                                      (sq) =>
                                        !typeFilter ||
                                        sq.discountType === typeFilter,
                                    )
                                    .map((sq, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{sq.discountName || ""}</td>
                                        <td>{sq.discountType}</td>
                                        <td>
                                          {sq.relatedItem?.[0]?.name?.name ||
                                            "-"}
                                        </td>
                                        <td>
                                          {sq.relatedItem?.[0]
                                            ?.medicineItemName || "-"}
                                        </td>
                                        <td>{sq.expiredDay || 0}</td>
                                        <td>{sq.itemBase || 0}</td>
                                        <td>
                                          {sq?.discountRate === "FOC"
                                            ? "FOC"
                                            : sq?.discountRate}
                                        </td>
                                        <td>
                                          {sq?.discountRate === "FOC"
                                            ? sq.focUnit?.[0]?.name ||
                                              sq.focItem?.[0]
                                                ?.medicineItemName ||
                                              sq.focItem?.[0]?.name?.name ||
                                              "FOC"
                                            : sq?.discountRate === "Amount"
                                              ? sq?.discountValue
                                              : sq?.discountValue + " %"}
                                        </td>
                                        <td className="text-center">
                                          <Link
                                            to={"/dis-update/" + sq._id}
                                            className="btn btn-sm btn-warning"
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className="btn btn-sm btn-danger"
                                            onClick={(e) => handleDelete(sq._id)}
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}

                              {showFilterList && (
                                <tbody>
                                  {filterList
                                    .filter(
                                      (sq) =>
                                        !typeFilter ||
                                        sq.discountType === typeFilter,
                                    )
                                    .map((sq, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{sq.discountName || ""}</td>
                                        <td>{sq.discountType}</td>
                                        <td>
                                          {sq.relatedItem?.[0]?.name?.name ||
                                            "-"}
                                        </td>
                                        <td>
                                          {sq.relatedItem?.[0]
                                            ?.medicineItemName || "-"}
                                        </td>
                                        <td>{sq.expiredDay || 0}</td>
                                        <td>{sq.itemBase || 0}</td>
                                        <td>
                                          {sq?.discountRate === "FOC"
                                            ? "FOC"
                                            : sq?.discountRate}
                                        </td>
                                        <td>
                                          {sq?.discountRate === "FOC"
                                            ? sq.focUnit?.[0]?.name ||
                                              sq.focItem?.[0]
                                                ?.medicineItemName ||
                                              sq.focItem?.[0]?.name?.name ||
                                              "FOC"
                                            : sq?.discountRate === "Amount"
                                              ? sq?.discountValue
                                              : sq?.discountValue + " %"}
                                        </td>
                                        <td className="text-center">
                                          <Link
                                            to={"/dis-update/" + sq._id}
                                            className="btn btn-sm btn-warning"
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className="btn btn-sm btn-danger"
                                            onClick={(e) =>
                                              handleDelete(sq._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                          &nbsp;
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Discount
                open={open}
                close={() => setOpen(false)}
                setDisLists={setDisLists}
                disLists={disLists}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Income;
